<div *ngIf="show" class="snackbar-wrap" [ngClass]="[type]" @state>
  <div class="snackbar-content">
    <div class="snackbar-image-container">
      <img src="assets/{{titleImage}}" alt="" />
    </div>
    <p class="snackbar-text">
      <span class="lead"> {{ title }}: </span>
      <span class="message">
        {{ message }}
      </span>
    </p>
  </div>
  <button class="snackbar-close" (click)="closeSnackbar()">
    <img src="" alt="" />
  </button>
</div>
